import React, { useState, useEffect } from "react";
import axios from "axios";
import Articles from "./Articles";
import { newss } from "./adminLogin";
var i = 0;
function News() {
  const [news, setNews] = useState([]);
  useEffect(() => {
    async function getNews() {
      await axios
        .get(
          "https://vaxtrail.herokuapp.com/hospitals/news"
        )
        .then(function (response) {
          // handle success
          console.log(response);
          setNews(response.data.articles);
        })
        .catch(function (error) {
          // handle error
          setNews(newss)
        });
    }
    getNews();
  }, []);
  return (
    <div className="news-clm">
      <h1 className="stats-heading">LATEST COVID-19 NEWS</h1>
      <div className="news">
        {news.map((x) => {
          return (
            <Articles
              key={i++}
              img={x.urlToImage}
              url={x.url}
              title={x.title}
              description={x.description}
            />
          );
        })}
      </div>
    </div>
  );
}

export default News;
